import React from 'react';
import { Trophy, Ghost, Heart, Cog } from 'lucide-react';
import Tooltip from '../../ui/Tooltip';

interface LeaderboardTabsProps {
  selectedType: string;
  onSelect: (type: string) => void;
}

const TABS = [
  { 
    id: 'favorite', 
    label: 'Most Popular',
    icon: Trophy,
    tooltip: 'Based on user votes for their favorite animatronics'
  },
  { 
    id: 'scarier', 
    label: 'Scariest',
    icon: Ghost,
    tooltip: 'Based on user votes for the scariest animatronics'
  },
  { 
    id: 'cuter', 
    label: 'Cutest',
    icon: Heart,
    tooltip: 'Based on user votes for the cutest animatronics'
  },
  { 
    id: 'technical', 
    label: 'Most Impressive',
    icon: Cog,
    tooltip: 'Based on user votes for technical impressiveness'
  },
];

const LeaderboardTabs: React.FC<LeaderboardTabsProps> = ({ selectedType, onSelect }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {TABS.map(tab => (
        <Tooltip key={tab.id} content={tab.tooltip}>
          <button
            onClick={() => onSelect(tab.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all duration-300 ${
              selectedType === tab.id
                ? 'bg-brand text-white shadow-lg shadow-brand/20'
                : 'bg-background text-content-secondary hover:text-content-primary hover:bg-background-secondary'
            }`}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </button>
        </Tooltip>
      ))}
    </div>
  );
};

export default LeaderboardTabs;